import { render, staticRenderFns } from "./PPCases.vue?vue&type=template&id=35c647fa"
import script from "./PPCases.vue?vue&type=script&lang=js"
export * from "./PPCases.vue?vue&type=script&lang=js"
import style0 from "./PPCases.vue?vue&type=style&index=0&id=35c647fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports